export default {
  store: {
    type: Object,
    default: null,
  },
  zIndex: {
    type: Number,
    default: null,
  },
  // 是否启用单条数据选择
  isSingleChoose: {
    type: Boolean,
    default: false,
  },
  customAddTable: {
    type: Boolean,
    default: false,
  },
  valueIsObject: {
    type: Boolean,
    default: false,
  },
  fontSize: {
    type: Number,
    default: 14,
  },
  field: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number, Array, Object],
    default: '',
  },
  selectedArr: {
    type: Array,
    default: () => [],
  },
  selectedArrKey: {
    type: String,
    default: 'id',
  },
  sideAddKey: {
    type: String,
    default: 'id',
  },
  openSelectedArr: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '商品编码/商品名称',
  },
  onOkAndContinue: {
    type: Boolean,
    default: false,
  },
  onOkAndContinueKey: {
    type: String,
    default: null,
  },
  isReadOnly: {
    type: Boolean,
    default: false,
  },
  // 侧滑宽度
  sideModalWidth: {
    type: Number,
    default: 556,
  },
  // 侧滑或者弹出窗名称
  modelTitle: {
    type: String,
    default: '添加商品',
  },
  // 取数据的url
  modelTableDataUrl: {
    type: String,
    default: '',
  },
  // 请求table接口得参数
  tableRequestParam: {
    type: [String, Object],
    default: () => {},
  },
  // 请求table接口请求方式
  tableRequestMethod: {
    type: String,
    default: 'get',
  },
  //添加明细之后是否重新刷新表格选中状态
  addTableRefresh: {
    type: Boolean,
    default: false,
  },
  // 添加数据的url
  addTableUrl: {
    type: String,
    default: '',
  },
  // 添加数据的参数
  addrequestData: {
    type: [String, Object],
    default: () => {},
  },
  // 添加数据的Key
  addKey: {
    type: String,
    default: '',
  },
  // 添加数据的请求方式，默认post
  requestype: {
    type: String,
    default: 'post',
  },

  // 侧滑或者弹出窗种表格得列定义
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  // 是否展示全选按钮
  showAllIconSelection: {
    type: Boolean,
    default: true,
  },
  needCompareParam: {
    type: Object,
    default: null,
  },
  dispatchComponent: {
    type: [Object],
    default: null,
  },
  criteriaCode: {
    type: String,
    default: '',
  },
  // --------------以下参数为扩展tag功能添加-lqn 20190805------------
  isTag: {
    type: Boolean,
    default: false,
  },
  tagMultiple: {
    type: Boolean,
    default: false,
  },
  initModal: {
    type: Boolean,
    default: true,
  },
  text: {
    type: String,
    default: '选择',
  },
  tagShowParam: {
    type: Object,
    default: () => {
      return {
        name: 'name',
        value: 'code',
      }
    },
  },
  isSideStyle: {
    type: Boolean,
    default: false,
  },
  modelTableDef: {
    type: Object,
  },
  // ------------------表格上方查询配置查询条件功能扩展参数-lqn 20190809-------------
  queryGroupUrl: {
    type: String,
    default: '',
  },
  showOfSearchInput: {
    type: Boolean,
    default: true,
  },
  // -----------------支持后台控制选择按钮置灰--------------------------
  // 注意：此功能只能在使用侧滑时使用，tag类型与普通类型（需要显示选中元素）不支持
  isServerControlChoose: {
    type: Boolean,
    default: false,
  },
  // -----------------2380 【高耗用户易用性优化】借货场景中，寄售场景转使用交互体验改进 --------------------------
  tipMessage: {
    // 增加顶部提示信息
    type: Object,
    default: null,
  },
  begFormData: {
    type: Object,
  },
  needWatchToUpdateFormCreateData: {
    // 用于寄售使用单监听指定字段更新数据
    type: String,
  },
  consignmentUsedAbleSelectAll: {
    // 用于寄售使用单，当selectedArr.length === 0时，全选按钮置灰，是否开启此项功能
    type: Boolean,
    default: false,
  },
  openAddTableUrlReturnDataToBegFormDataOrTable: {
    // 是否开启手动更新指定值
    type: Boolean,
    default: false,
  },
  // 如果配置了AddTableDataUrl，会发起请求添加数据，设置此参数会将请求返回的数据按照相同属性更新至begFormData中
  // 栗子：begFormData:{code1:"1011",code2:"2222"}
  // 此参数为对象：manualUpdateBegFormData:{code1: 'order.code',code2:'order.name'}
  // order.code order.name 为请求返回的数据
  manualUpdateBegFormData: {
    type: Object,
    default: null,
  },
  // 如果配置了AddTableDataUrl，会发起请求添加数据，设置此参数会将请求返回的数据按照相同属性更新至begFormData中
  // 栗子：需要更新的表格属性
  // manualUpdateCustomTableDataParam : 'data.items'
  // data.items 为请求返回的数据
  manualUpdateCustomTableDataParam: {
    type: String,
    default: '',
  },
  // rowclick触发后是否自动关闭侧滑
  isAutoClosed: {
    type: Boolean,
    default: false,
  },
  plusKey: {
    // 加减号，依赖的key
    type: String,
    default: 'id',
  },
  disabledCode: {
    // table表前icon根据code置灰(不可选)
    type: String,
    default: '',
  },
  showIconSelection: {
    // isReadOnly 为 true 是有效
    type: Boolean,
    default: false,
  },
  addSeparator: String,
  addTableUrlResDataHasSelectedArrKey: {
    type: Boolean,
    default: false,
  },
  pageSizeOption: {
    type: Array,
    default: () => [10, 20, 30, 40],
  },
  //高级查询是否重置
  isShowReset: {
    type: Boolean,
    default: true,
  },
  //默认的页面size
  defaultPageSize: {
    type: [String, Number],
    default: null,
  },
  //是否拷贝传入的数据
  isCopy: Boolean,
}
